import styles from "../../../styles/Login.module.css";
import BoxPadraoSenha from "../BoxPadraoSenha";
import CustomInput from "../CustomInput";

export default function Step2({ values, handleChange, handleBlur, errors, touched, submitting }) {
    return (
        <div style={{ flex: 1 }}>
            <div className={`${styles.formLogin} ${styles.divisor}`}>
                <CustomInput placeholder="Digite sua senha" required label="Senha" name="password" value={values.password} onChange={handleChange} onBlur={handleBlur} errors={errors} touched={touched} disabled={submitting} tipoInputRight="password" />

                <CustomInput placeholder="Confirme sua senha" required label="Confirmar senha" name="password_confirmation" value={values.password_confirmation} onChange={handleChange} onBlur={handleBlur} errors={errors} touched={touched} disabled={submitting} tipoInputRight="password" />
            </div>

            <BoxPadraoSenha values={values} name="password" />
        </div>
    );
}
